<div class="wrapper">
  <div class="frame">
    <div class="existingBuilding section">
      <div class="tile clickable" (click)="addToExistingBuilding()">
        <img src="assets/Address_existing_building.svg" />
        <span
          class="optionText"
          i18n="@@buildinglist.reassignaddress.addaddresstoexistingbuilding"
        >
          Add selected address <br />to
          <span class="bolder">existing building</span>
        </span>
      </div>
    </div>
    <span class="divider"></span>
    <div class="createBuilding section">
      <i class="fas fa-times clickable" (click)="onClose()"></i>
      <div class="tile clickable" (click)="createNewBuilding()">
        <img src="assets/Address_create_building.svg" />
        <span
          class="optionText"
          i18n="@@buildinglist.reassignaddress.createbuildingbyaddress"
        >
          Create
          <span class="bolder">building</span> <br />
          with selected address
        </span>
      </div>
    </div>
  </div>
</div>
<app-reassign-address-existing-building
  [buildingSurveyVm]="buildingSurveyVm"
  [allBuildingSurveyVms]="allBuildingSurveyVms"
  (closeReassignAddress)="onCloseExistingBuilding()"
  [areaId]="areaId"
  (reloadBuildingList)="innerReloadBuildingList()"
  *ngIf="assignToExistingBuilding"
>
</app-reassign-address-existing-building>
